"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.recaptureSagas = exports.getIsEnquiring = void 0;
var effects_1 = require("redux-saga/effects");
var RecaptureAction_1 = require("@/pages/search/actions/sfilter/RecaptureAction");
var StorageApi_1 = require("@/api/browser/StorageApi");
var GlobalAction_1 = require("@/pages/common/actions/GlobalAction");
// export const getSfilterHasUpdated = (state: RootSearchState) => state.sfilter ? state.sfilter.hasUpdated : false;
exports.getIsEnquiring = function (state) {
    return state.enquire ? state.enquire.isActive : false;
};
var hasPromptExpired = function (date) {
    return __generator(this, function (_a) {
        return [2 /*return*/, ((new Date()).getTime() - date.getTime() > 1000 * 60 * 60 * 24)];
    });
};
var getHasPrompt = function (key) {
    var hasPromptObjStr, hasPromptObj, hasPrompt, hasExpired;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.call(StorageApi_1.readLocalStorage, key)];
            case 1:
                hasPromptObjStr = _a.sent();
                if (!hasPromptObjStr)
                    return [2 /*return*/, false];
                try {
                    hasPromptObj = JSON.parse(hasPromptObjStr);
                }
                catch (e) {
                    return [2 /*return*/, false];
                }
                if (typeof hasPromptObj !== 'object')
                    return [2 /*return*/, false];
                hasPrompt = { created: new Date(hasPromptObj.created) };
                return [4 /*yield*/, effects_1.call(hasPromptExpired, hasPrompt.created)];
            case 2:
                hasExpired = _a.sent();
                if (hasExpired)
                    return [2 /*return*/, false];
                return [2 /*return*/, true];
        }
    });
};
var setHasPrompt = function (key) {
    var hasPrompt;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                hasPrompt = {
                    created: new Date(),
                };
                return [4 /*yield*/, effects_1.call(StorageApi_1.setLocalStorage, key, JSON.stringify(hasPrompt))];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
/* Show recapture on tab re-focus */
var watchOnTabRefocus = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.take(GlobalAction_1.default.ON_TAB_BLUR)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.take(GlobalAction_1.default.ON_TAB_FOCUS)];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.put(RecaptureAction_1.default.doRecapture())];
            case 3:
                _a.sent();
                return [3 /*break*/, 0];
            case 4: return [2 /*return*/];
        }
    });
};
/* Hide recapture tab on close */
var watchOnCloseClick = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(RecaptureAction_1.default.ON_RECAPTURE_CLOSE_CLICK)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(RecaptureAction_1.default.closeDialog())];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
/**
 * Show recapture only if the follow conditions all met:
 * - Has some change in search filter
 * - Not already in enquiring box
 * - Not prompted recently
 */
var watchDoRecapture = function () {
    var hasUpdated, isEnquiring, hasRecaptured;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 6];
                return [4 /*yield*/, effects_1.take(RecaptureAction_1.default.ON_DO_RECAPTURE)];
            case 1:
                _a.sent();
                hasUpdated = false;
                return [4 /*yield*/, effects_1.select(exports.getIsEnquiring)];
            case 2:
                isEnquiring = _a.sent();
                if (isEnquiring)
                    return [3 /*break*/, 0];
                if (!hasUpdated)
                    return [3 /*break*/, 0];
                return [4 /*yield*/, effects_1.call(getHasPrompt, 'hasPromptRecapture')];
            case 3:
                hasRecaptured = _a.sent();
                if (hasRecaptured)
                    return [3 /*break*/, 0];
                return [4 /*yield*/, effects_1.put(RecaptureAction_1.default.recapture())];
            case 4:
                _a.sent();
                return [4 /*yield*/, effects_1.call(setHasPrompt, 'hasPromptRecapture')];
            case 5:
                _a.sent();
                return [3 /*break*/, 0];
            case 6: return [2 /*return*/];
        }
    });
};
/* Close the dialog and do save search if the save button is clicked */
var watchOnRecaptureSaveClick = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(RecaptureAction_1.default.ON_RECAPTURE_SAVE_CLICK)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(RecaptureAction_1.default.closeDialog())];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var recaptureSagas = {
    watchOnTabRefocus: watchOnTabRefocus,
    watchOnCloseClick: watchOnCloseClick,
    watchOnRecaptureSaveClick: watchOnRecaptureSaveClick,
    watchDoRecapture: watchDoRecapture,
};
exports.recaptureSagas = recaptureSagas;
